import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getData } from "../../../../services/library";
const StyledBox = ({ label, value, name }) => (
  <>
    {" "}
    <Typography
      variant="subtitle2"
      color="textSecondary"
      sx={{ marginBottom: "-5px", marginTop: "-4px" }}
    >
      {" "}
      {label}{" "}
    </Typography>{" "}
    <Typography
      variant="body2"
      sx={{ marginBottom: "-5px", marginTop: "-5px" }}
    >
      {" "}
      {value || "No registrado"}{" "}
    </Typography>{" "}
  </>
);

export default function DetalleDirecSeleccionada({
  clienteSeleccionado,
  direccionSeleccionada,
}) {
const [ultCompra, setUltCompra] = useState([])

useEffect(() => {
  getData("/envasado_pedidos/ultimacompra/"+direccionSeleccionada.id, setUltCompra)
}, [])


  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "10px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        backgroundColor: "#f9f9f9",
        width: "100%",
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={2}>
          <StyledBox
            label="CUIT/DNI"
            value={direccionSeleccionada?.cuit}
            name="cuit"
          />
        </Grid>
        <Grid item xs={2}>
          <StyledBox
            label="Condición IVA"
            value={direccionSeleccionada?.cond_iva}
            name="cond_iva"
          />
        </Grid>

        <Grid item xs={4}>
          <StyledBox
            label="Observaciones de Cliente"
            value={direccionSeleccionada?.obs_cliente}
            name="observaciones"
          />
        </Grid>

        <Grid item xs={2}>
          <StyledBox
            label="Envase 10 KG"
            value={direccionSeleccionada?.envase_10_kg}
            name="envase_10_kg"
          />
        </Grid>

        <Grid item xs={2}>
          <StyledBox
            label="Envase 15 KG"
            value={direccionSeleccionada?.envase_15_kg}
            name="envase_15_kg"
          />
        </Grid>

        <Grid item xs={2}>
          <StyledBox
            label="Envase 45 KG"
            value={direccionSeleccionada?.envase_45_kg}
            name="envase_45_kg"
          />
        </Grid>

        <Grid item xs={6}>
          <StyledBox
            label="MAILS"
            value={direccionSeleccionada?.mails_cliente}
            name="mails"
          />
        </Grid>

        {direccionSeleccionada?.telefono_1 && (
          <Grid item xs={2}>
            <StyledBox
              label="Teléfono"
              value={direccionSeleccionada.telefono_1}
              name="telefono_1"
            />
          </Grid>
        )}
        {direccionSeleccionada?.telefono_2 && (
          <Grid item xs={2}>
            <StyledBox
              label="Teléfono"
              value={direccionSeleccionada.telefono_2}
              name="telefono_2"
            />
          </Grid>
        )}
        {direccionSeleccionada?.telefono_3 && (
          <Grid item xs={2}>
            <StyledBox
              label="Teléfono"
              value={direccionSeleccionada.telefono_3}
              name="telefono_3"
            />
          </Grid>
        )}

        {direccionSeleccionada?.observaciones && (
          <Grid item xs={4}>
            <StyledBox
              label="Observación de Dirección"
              value={direccionSeleccionada.observaciones}
              name="observaciones_dir"
            />
          </Grid>
        )}
        {ultCompra.length>0?
        <>

          <Grid item xs={2}>
            <StyledBox
              label="Fecha de última compra"
              value={ultCompra[0].fecha_format}
              name="fecha_format"
            />
          </Grid>
          <Grid item xs={10}>
            <StyledBox
              label="Productos de última compra"
              value={ultCompra[0].productos}
              name="productos"
            />
          </Grid>
          </>
        :null}
      </Grid>
    </Box>
  );
}
